// Libraries
var React = require("react");

// Style
require("./ImageBanner.scss");

class ImageBannerModule extends React.Component {
	render() {
		const hasTitle = this.props.data.title !== '';
		const hasSubtitle = this.props.data.subtitle !== '';
		const hasButton = this.props.data.button.url && this.props.data.button.caption;
		const isSplit = hasTitle && (hasSubtitle || hasButton);
		return (
			<section id={this.props.data.id} className={`c-image-banner${isSplit ? " c-image-banner--split" : ""}${this.props.data.isPremium ? " c-image-banner--premium" : ""}`}>
				<div className="c-image-banner__inner">
					<div className="c-image-banner__inner__inner">
						{hasTitle &&
							<h2 className="c-image-banner__title">{this.props.data.title}</h2>
						}
						{(hasSubtitle || hasButton) &&
							<div className="c-image-banner__content">
								{hasSubtitle &&
									<p className="c-image-banner__subtitle">{this.props.data.subtitle}</p>
								}
								{hasButton &&
									<p className="c-image-banner__button">
										<a href={this.props.data.button.url} className={`c-button c-button--small c-button--right-arrow ${this.props.data.isPremium ? "c-button--premium" : ""}`} target={this.props.data.button.newWindow ? "_blank" : "_self"} rel={this.props.data.button.newWindow ? "noopener noreferrer" : undefined}>{this.props.data.button.caption}</a>
									</p>
								}
							</div>
						}
					</div>
				</div>
				<picture>
					<source media="(min-width: 1441px)" srcSet={this.props.data.backgroundImage.extraLargeUrl} />
					<source media="(min-width: 1025px)" srcSet={this.props.data.backgroundImage.largeUrl} />
					<source media="(min-width: 751px)" srcSet={this.props.data.backgroundImage.mediumUrl} />
					<img src={this.props.data.backgroundImage.smallUrl} alt={this.props.data.backgroundImage.altText} className="c-image-banner__image" />
				</picture>
			</section>
		);
	}
}

module.exports = ImageBannerModule;



// WEBPACK FOOTER //
// ./src/components/ImageBanner/ImageBanner.js